







import { Component, Prop, Vue } from 'vue-property-decorator'
import { TypeformResponseAnswer } from '@/api/model/typeform/typeform-response-answer'

@Component
export default class FieldTypeChoice extends Vue {
    @Prop({ required: true }) readonly value!: TypeformResponseAnswer

    get choices(): string {
        return this.value.choices.map(v => v.label)
            .filter(v => !!v)
            .join(', ')
    }
}
